import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { msalConfig } from '../services/msal';

const useAuthRedirect = (auth) => {
  const { instance } = useMsal();

  useEffect(() => {
    const now = new Date();
    const interval = setInterval(async () => {
      await auth.checkToken();
      if (auth.authExpires > now) {
        if (!auth.authToken) {
          instance.loginRedirect({ ...msalConfig.loginRequest, redirectStartPage: '/' });
          clearInterval(interval);
        } else if (auth.isTokenExpired()) {
          instance.loginRedirect({ ...msalConfig.loginRequest, redirectStartPage: '/' });
          clearInterval(interval);
        }
      } else {
        await instance.logoutRedirect();
      }
    }, 18000);
    return () => clearInterval(interval); // clear the interval on unload to prevent memory leaks
  }, [auth, instance]);
};

export default useAuthRedirect;
